module.exports = __webpack_public_path__ + "static/media/phi.1e06ff0d.png";